<v4-custom-select
  [placeholder]="placeholder"
  [size]="size"
  [textItem]="textView"
  [showTextItem]="textView"
  [(visible)]="visible"
>
  <div class="v4-layout-dropdown w-[560px]">
    <div class="v4-filter-list pb-[30px]">
      <div class="v4-filter-item" *ngFor="let group of groupList">
        <div
          class="v4-filter v4-filter-selectable"
          [class.selected]="selectedGroup === group.id"
          (click)="onSelectGroup(group)"
        >
          {{ group.name }}
        </div>
      </div>
    </div>

    <div class="v4-option-list pb-[30px]">
      <div class="v4-option-item" *ngFor="let staff of staffListOfGroup">
        <div class="v4-option" [class.selected]="selectedStaff.has(staff.value)" (click)="onSelectStaff(staff)">
          {{ staff.label }}
        </div>
      </div>
    </div>

    <div class="flex flex-row items-center justify-between" *ngIf="multiple">
      <a href="javascript:void(0)" class="text-primary" (click)="onReset()">{{ 'word.reset' | translate }}</a>
      <div>
        <button nz-button nzSize="large" class="mr-3" (click)="onCancel()">
          {{ 'word.cancel' | translate }}
        </button>
        <button nz-button nzType="primary" nzSize="large" (click)="onConfirm()">
          {{ 'word.confirm' | translate }}
        </button>
      </div>
    </div>
  </div>
</v4-custom-select>
